import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isPoWorkflowModulePath, resetPoWorkflowFilters } from './po_workflow_filters.store';

export const PoWorkflowFilterScope = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isPoWorkflowModulePath(pathname)) {
      resetPoWorkflowFilters();
    }
  }, [pathname]);

  return null;
};
